import { Yii } from 'libraries/interfaces/Yii';

const NOTIFICATIONS = {
    getSmsTemplatesError: Yii.t('wui-sasha-js', 'Une erreur est survenue lors du chargement des modèles'),
    getOneSmsTemplate: Yii.t('wui-sasha-js', 'Une erreur est survenue lors du chargement des templates')
};

export const WORDING = {
    ...NOTIFICATIONS
};